<template>
  <div class="czzn-cpjs">
    <div class="cjwt-main-tit"><h2>其他问题：</h2></div>
    <div class="cjwt_main_con">
      <v-wd v-for="(item, index) in wdArr" :key="index" :wtda="item" ></v-wd>
    </div>
  </div>
</template>
<script>
import vWd from '../../components/wd.vue';

export default {
  name: 'cjwt_gncz',
  components: {
    vWd,
  },
  data() {
    return {
      wdArr: [
        {
          question: '为什么“财务初始余额”不能编辑、没有“保存”按钮？',
          answer: '财务初始余额只有在账套启用当期才能编辑。如果已经结账到下期，初始余额不能修改；如确实需要修改的，必须在结账中“取消结账到上期”。',
        },
        {
          question: '如何修改账套众公司名称？',
          answer: '在企业管理工作台中，在我的账套中选中要修改的账套，点击操作列的“修改”按钮进行修改，修改后保存即可。',
        },
        {
          question: '财务期初余额录入时，为什么有的蓝色格子是不能录入数据的？',
          answer: '蓝色的格子是系统根据其他单元格录入的数据自动计算而得，比如：非明细科目的余额是根据明细科目汇总计算得到；年初数根据期初数和累计发生数计算得到。数据录入并保存后可以显示自动计算的数据。',
        },
        {
          question: '账套启用期间可以修改吗？',
          answer: '初始化时，可选择启用的期间，但账套启用后会计启用期间不可以修改。',
        },
        {
          question: '不使用的科目可以删除吗？',
          answer: '如果是未使用过的明细科目，可以直接删除（系统预制科目不能删除）；如果是曾用过且已经结平的科目，则不能被删除，只能进行禁用。',
        },
      ],
    };
  },
};
</script>
